export const APIBASE = process.env.APIBASE;
export const SOCKET_SERVER = process.env.SOCKET_SERVER;
export const SITE = process.env.SITE;
//# sourceMappingURL=config.js.map